"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteApi = exports.FavoriteApiFactory = exports.FavoriteApiFp = exports.FavoriteApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * FavoriteApi - axios parameter creator
 * @export
 */
const FavoriteApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add document to favorite
         * @param {InputAddDocumentToFavorite} [inputAddDocumentToFavorite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentToFavorite: (inputAddDocumentToFavorite, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite/documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputAddDocumentToFavorite, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add folder to favorite
         * @param {InputAddFolderToFavorite} [inputAddFolderToFavorite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderToFavorite: (inputAddFolderToFavorite, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite/folders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputAddFolderToFavorite, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get dashboard favorite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFavorite: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get favorite documents
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteDocuments: (filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite/documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get favorite folders
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteFolders: (filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite/folders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove document from favorite
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDocumentFromFavorite: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('removeDocumentFromFavorite', 'id', id);
            const localVarPath = `/favorite/documents/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove folder from favorite
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderFromFavorite: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('removeFolderFromFavorite', 'id', id);
            const localVarPath = `/favorite/folders/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FavoriteApiAxiosParamCreator = FavoriteApiAxiosParamCreator;
/**
 * FavoriteApi - functional programming interface
 * @export
 */
const FavoriteApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FavoriteApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Add document to favorite
         * @param {InputAddDocumentToFavorite} [inputAddDocumentToFavorite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentToFavorite(inputAddDocumentToFavorite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addDocumentToFavorite(inputAddDocumentToFavorite, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add folder to favorite
         * @param {InputAddFolderToFavorite} [inputAddFolderToFavorite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderToFavorite(inputAddFolderToFavorite, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addFolderToFavorite(inputAddFolderToFavorite, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get dashboard favorite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFavorite(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDashboardFavorite(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get favorite documents
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteDocuments(filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFavoriteDocuments(filter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get favorite folders
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteFolders(filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFavoriteFolders(filter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Remove document from favorite
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDocumentFromFavorite(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeDocumentFromFavorite(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Remove folder from favorite
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderFromFavorite(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeFolderFromFavorite(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FavoriteApiFp = FavoriteApiFp;
/**
 * FavoriteApi - factory interface
 * @export
 */
const FavoriteApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FavoriteApiFp)(configuration);
    return {
        /**
         *
         * @summary Add document to favorite
         * @param {InputAddDocumentToFavorite} [inputAddDocumentToFavorite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentToFavorite(inputAddDocumentToFavorite, options) {
            return localVarFp.addDocumentToFavorite(inputAddDocumentToFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add folder to favorite
         * @param {InputAddFolderToFavorite} [inputAddFolderToFavorite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderToFavorite(inputAddFolderToFavorite, options) {
            return localVarFp.addFolderToFavorite(inputAddFolderToFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get dashboard favorite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFavorite(options) {
            return localVarFp.getDashboardFavorite(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get favorite documents
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteDocuments(filter, options) {
            return localVarFp.getFavoriteDocuments(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get favorite folders
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteFolders(filter, options) {
            return localVarFp.getFavoriteFolders(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove document from favorite
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDocumentFromFavorite(id, options) {
            return localVarFp.removeDocumentFromFavorite(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove folder from favorite
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderFromFavorite(id, options) {
            return localVarFp.removeFolderFromFavorite(id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FavoriteApiFactory = FavoriteApiFactory;
/**
 * FavoriteApi - object-oriented interface
 * @export
 * @class FavoriteApi
 * @extends {BaseAPI}
 */
class FavoriteApi extends base_1.BaseAPI {
    /**
     *
     * @summary Add document to favorite
     * @param {InputAddDocumentToFavorite} [inputAddDocumentToFavorite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    addDocumentToFavorite(inputAddDocumentToFavorite, options) {
        return (0, exports.FavoriteApiFp)(this.configuration).addDocumentToFavorite(inputAddDocumentToFavorite, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add folder to favorite
     * @param {InputAddFolderToFavorite} [inputAddFolderToFavorite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    addFolderToFavorite(inputAddFolderToFavorite, options) {
        return (0, exports.FavoriteApiFp)(this.configuration).addFolderToFavorite(inputAddFolderToFavorite, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get dashboard favorite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    getDashboardFavorite(options) {
        return (0, exports.FavoriteApiFp)(this.configuration).getDashboardFavorite(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get favorite documents
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    getFavoriteDocuments(filter, options) {
        return (0, exports.FavoriteApiFp)(this.configuration).getFavoriteDocuments(filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get favorite folders
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    getFavoriteFolders(filter, options) {
        return (0, exports.FavoriteApiFp)(this.configuration).getFavoriteFolders(filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove document from favorite
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    removeDocumentFromFavorite(id, options) {
        return (0, exports.FavoriteApiFp)(this.configuration).removeDocumentFromFavorite(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove folder from favorite
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    removeFolderFromFavorite(id, options) {
        return (0, exports.FavoriteApiFp)(this.configuration).removeFolderFromFavorite(id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FavoriteApi = FavoriteApi;
